export default "__VITE_ASSET__D9Ti_QhW__"